import move from "./appointment/move";

export const OPEN_FAN_KEY = 'communication-appointment';

export const LIST_TYPE__APPLICANT = 'applicant';
export const LIST_TYPE__CUSTOMER = 'customer';

const store = {
	namespaced: true,
	modules: {
		move,
	},
	state: {
		show: false,
		jobId: undefined,
		jobProfileId: undefined,
		listType: undefined,
		onClose: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setListType', data.listType);
			commit('setJobId', data.jobId);
			commit('setJobProfileId', data.jobProfileId);
			commit('setOnClose', data.onClose);

			commit('setShow', true);
		},
		close ({commit, state})
		{
			if (state.onClose)
			{
				state.onClose();
			}

			commit('setShow', false);

			commit('setListType', undefined);
			commit('setJobId', undefined);
			commit('setJobProfileId', undefined);
			commit('setOnClose', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setListType: (state, value) => state.listType = value,
		setJobId: (state, value) => state.jobId = value,
		setJobProfileId: (state, value) => state.jobProfileId = value,
		setOnClose: (state, value) => state.onClose = value,
	},
};

export default store;
